import {
  GENDERS,
  SMOKERS,
  LIFE_STAGE,
  COVER_TYPE
} from '~/constants/form.strings'

import {
  PAGE_DATA
} from '~/constants/funnel/car-insurance.js'

export const WIDGET_DATA_OBJ = {
  [VERTICAL.HEALTH_INSURANCE]: {
    title: 'I’d like <strong>health insurance</strong> cover for: ',
    redirect: '/health-insurance/quote/form/details/',
    formItemsArr: [
      'life_stage',
      'age',
      'cover_type',
      'postcode',
      'health_fund'
    ],
    formData: [
      {
        component: 'MoleculesSelectDropdown',
        componentClass: 'w-1/2',
        props: {
          name: 'life_stage',
          label: '',
          placeholder: 'Select',
          dataInputDisplay: 'label',
          dataListDisplay: 'label',
          dataValue: 'value',
          dataArr: LIFE_STAGE
        }
      },
      {
        component: 'AtomsInput',
        componentClass: 'w-1/2',
        props: {
          name: 'age',
          placeholder: 'Enter your age',
          modelType: 'number',
          label: '',
          maxlength: '3',
          darkPlaceholder: true
        }
      },
      {
        component: 'MoleculesSelectDropdown',
        componentClass: 'w-full',
        props: {
          name: 'cover_type',
          label: '',
          placeholder: 'Select cover level',
          dataListDisplay: 'label',
          dataInputDisplay: 'label',
          dataValue: 'value',
          dataArr: COVER_TYPE
        }
      },
      {
        component: 'MoleculesPostcode',
        componentClass: 'w-full',
        props: {
          name: 'postcode',
          label: '',
          darkPlaceholder: true
        }
      },
      {
        component: 'MoleculesSelectDropdown',
        componentClass: 'w-full',
        props: {
          name: 'health_fund',
          label: '',
          placeholder: 'Your current fund',
          dataListDisplay: 'label',
          dataInputDisplay: 'label',
          dataValue: 'value',
          dataSrc: 'https://asset.compareclub.com.au/json/fundlist.json'
        }
      }
    ]
  },

  [VERTICAL.LIFE_INSURANCE]: {
    title: 'I’d like <strong>life insurance</strong> cover for: ',
    redirect: '/life-insurance/quote/form/details/',
    formItemsArr: [
      'age',
      'cover_amount',
      'gender',
      'smoker',
      'occupation',
      'state'
    ],
    formData: [
      {
        component: 'AtomsInput',
        componentClass: 'w-1/2',
        props: {
          name: 'age',
          placeholder: 'Current age',
          modelType: 'number',
          label: '',
          maxlength: '3',
          darkPlaceholder: true
        }
      },
      {
        component: 'AtomsInput',
        componentClass: 'w-1/2',
        props: {
          name: 'cover_amount',
          placeholder: 'Cover amount',
          modelType: 'money',
          hasCurrency: true,
          label: '',
          darkPlaceholder: true
        }
      },
      {
        component: 'MoleculesSelectDropdown',
        componentClass: 'w-1/2',
        props: {
          name: 'gender',
          label: '',
          placeholder: 'Gender',
          dataListDisplay: 'label',
          dataInputDisplay: 'label',
          dataValue: 'value',
          dataArr: GENDERS
        }
      },
      {
        component: 'MoleculesSelectDropdown',
        componentClass: 'w-1/2',
        props: {
          name: 'smoker',
          label: '',
          placeholder: 'Smoker',
          dataListDisplay: 'label',
          dataInputDisplay: 'label',
          dataValue: 'value',
          dataArr: SMOKERS
        }
      },
      {
        componentClass: 'w-full',
        component: 'MoleculesOccupation',
        props: {
          name: 'occupation',
          label: '',
          placeholder: 'Occupation',
          dataListDisplay: 'name',
          dataInputDisplay: 'name',
          dataValue: '',
          hideDropdownIcon: true,
          characterDelay: 1
        }
      },
      {
        component: 'MoleculesStates',
        componentClass: 'w-full',
        props: {
          name: 'state',
          label: '',
          placeholder: 'Select cover state'
        }
      }
    ]
  },

  'Income Protection': {
    title: 'I’d like <strong>Income Protection Policies</strong> for: ',
    redirect: '/life-insurance/income-protection/quote/details/',
    formItemsArr: [
      'age',
      'annual_income',
      'gender',
      'smoker',
      'occupation',
      'state'
    ],
    formData: [
      {
        component: 'AtomsInput',
        componentClass: 'w-1/2',
        props: {
          name: 'age',
          placeholder: 'Current age',
          modelType: 'number',
          label: '',
          maxlength: '3',
          darkPlaceholder: true
        }
      },
      {
        component: 'AtomsInput',
        componentClass: 'w-1/2',
        props: {
          name: 'annual_income',
          placeholder: 'Annual Income',
          modelType: 'money',
          hasCurrency: true,
          label: '',
          darkPlaceholder: true
        }
      },
      {
        component: 'MoleculesSelectDropdown',
        componentClass: 'w-1/2',
        props: {
          name: 'gender',
          label: '',
          placeholder: 'Gender',
          dataListDisplay: 'label',
          dataInputDisplay: 'label',
          dataValue: 'value',
          dataArr: GENDERS
        }
      },
      {
        component: 'MoleculesSelectDropdown',
        componentClass: 'w-1/2',
        props: {
          name: 'smoker',
          label: '',
          placeholder: 'Smoker',
          dataListDisplay: 'label',
          dataInputDisplay: 'label',
          dataValue: 'value',
          dataArr: SMOKERS
        }
      },
      {
        componentClass: 'w-full',
        component: 'MoleculesOccupation',
        props: {
          name: 'occupation',
          label: '',
          placeholder: 'Occupation',
          dataListDisplay: 'name',
          dataInputDisplay: 'name',
          dataValue: '',
          hideDropdownIcon: true,
          characterDelay: 1
        }
      },
      {
        component: 'MoleculesStates',
        componentClass: 'w-full',
        props: {
          name: 'state',
          label: '',
          placeholder: 'Select cover state'
        }
      }
    ]
  }
}

export const ERROR_MAP_OBJ = {
  [VERTICAL.HEALTH_INSURANCE]: {
    default: {
      life_stage: 'Please select an option',
      age: 'Enter valid age',
      cover_type: 'Please select cover type',
      postcode: 'Please enter your valid postcode',
      health_fund: 'Please select health fund'
    },
    empty: {
      life_stage: 'Please select an option',
      age: 'Enter your age',
      cover_type: 'Please select cover type',
      postcode: 'Please enter your valid postcode',
      health_fund: 'Please select health fund'
    }
  },

  [VERTICAL.LIFE_INSURANCE]: {
    default: {
      age: 'Enter valid age',
      cover_amount: 'Enter valid amount ',
      gender: 'Select gender',
      smoker: 'Select smoker',
      occupation: 'Please select your occupation from list',
      state: 'Please enter your valid state'
    },
    empty: {
      age: 'Enter your age',
      cover_amount: 'Enter your amount ',
      gender: 'Select gender',
      smoker: 'Select option',
      occupation: 'Please select your occupation from list',
      state: 'Please enter your valid state'
    }
  },

  'Income Protection': {
    default: {
      age: 'Enter valid age',
      annual_income: 'Enter valid amount ',
      gender: 'Please select an option',
      smoker: 'Please select an option',
      occupation: 'Please select your occupation from list',
      state: 'Please select your state'
    },
    empty: {
      age: 'Enter your age',
      annual_income: 'Enter your amount ',
      gender: 'Please select an option',
      smoker: 'Please select an option',
      occupation: 'Please select your occupation from list',
      state: 'Please select your state'
    }
  }
}

export const HERO_WIDGET_DATA_OBJ = {
  [VERTICAL.HEALTH_INSURANCE]: {
    title: `
      Get a quote in <br class="hidden lg:block" />
      <strong class="font-extrabold">
        less than <br class="hidden lg:block" />
        2 mins
      </strong>
    `,
    redirect: '/health-insurance/quote/form/step2/',
    formItems: {
      life_stage: {
        component: 'MoleculesSelectDropdown',
        props: {
          placeholder: 'Who is this cover for?',
          label: '',
          dataInputDisplay: 'label',
          dataListDisplay: 'label',
          dataValue: 'value',
          dataArr: LIFE_STAGE
        }
      },
      postcode: {
        component: 'MoleculesPostcode',
        props: {
          label: '',
          placeholder: 'Enter your postcode',
          darkPlaceholder: true
        }
      }
    }
  },

  OVHC: {
    title: `
      Get a quick <br class="hidden lg:block" />
      quote
    `,
    redirect: '/health-insurance/visitors-visa-ovhc/step2/',
    formItems: {
      life_stage: {
        component: 'MoleculesSelectDropdown',
        props: {
          name: 'life_stage',
          label: 'Cover type',
          placeholder: 'Select cover type',
          dataValue: 'value',
          dataInputDisplay: 'label',
          dataListDisplay: 'label',
          dataArr: LIFE_STAGE
        }
      },
      visa_type: {
        component: 'MoleculesSelectDropdown',
        props: {
          name: 'visa_type',
          label: 'Visa type',
          placeholder: 'Select visa type',
          dataValue: 'value',
          dataArr: [
            {
              name: 'Visitor',
              value: 'Visitor'
            },
            {
              name: 'Working',
              value: 'Working'
            },
            {
              name: 'Students',
              value: 'Student'
            }
          ]
        }
      },
      visa_subtype: {
        component: 'MoleculesSelectDropdown',
        props: {
          label: 'Visa subclass',
          placeholder: 'Select visa subclass',
          dataInputDisplay: 'value',
          dataValue: 'value',
          dataArr: []
        }
      },
      visa_code: {
        component: 'AtomsInput',
        props: {
          placeholder: 'Input 3-4 digits Visa code',
          modelType: 'number',
          label: '',
          maxlength: '4'
        }
      }
    }
  },

  [VERTICAL.LIFE_INSURANCE]: {
    title: `
      Get a quote in <br class="hidden lg:block" />
      <strong class="font-extrabold">
        less than <br class="hidden lg:block" />
        2 mins
      </strong>
    `,
    redirect: '/life-insurance/quote/form/step1/',
    formItems: {
      age: {
        component: 'AtomsInput',
        props: {
          placeholder: 'Your current age',
          modelType: 'number',
          label: '',
          maxlength: '3',
          darkPlaceholder: true
        }
      },
      cover_amount: {
        component: 'AtomsInput',
        props: {
          placeholder: 'Amount of cover',
          modelType: 'money',
          hasCurrency: true,
          label: '',
          darkPlaceholder: true
        }
      }
    }
  },

  'Income Protection': {
    title: `
      Get a quote in <br class="hidden lg:block" />
      <strong class="font-extrabold">
        less than <br class="hidden lg:block" />
        2 mins
      </strong>
    `,
    redirect: '/life-insurance/income-protection/quote/',
    formItems: {
      age: {
        component: 'AtomsInput',
        props: {
          placeholder: 'Your current age',
          modelType: 'number',
          label: '',
          maxlength: '3',
          darkPlaceholder: true
        }
      },
      annual_income: {
        component: 'AtomsInput',
        props: {
          placeholder: 'Annual Income',
          modelType: 'money',
          hasCurrency: true,
          label: '',
          darkPlaceholder: true
        }
      }
    }
  },

  [VERTICAL.HOME_LOANS]: {
    title: 'Get a quick <br class="hidden lg:block" /> quote',
    redirect: '/home-loans/quote/form/step1/',
    formItems: {
      refinance: {
        component: 'MoleculesSelection',
        props: {
          name: 'refinance',
          type: 'radio',
          ticker: 'circle',
          options: [
            {
              value: '1',
              label: 'I want to refinance',
              name: 'refinance'
            },
            {
              value: '0',
              label: 'I want to buy a home',
              name: 'Purchase'
            }
          ]
        }
      }
    }
  },

  [VERTICAL.ENERGY]: {
    title: 'Get a quick <br class="hidden lg:block" /> quote',
    redirect: '/energy/quote/form/step2/',
    formItems: {
      fuel_type: {
        component: 'MoleculesSelectDropdown',
        props: {
          placeholder: 'What are you looking to compare',
          label: '',
          dataInputDisplay: 'label',
          dataListDisplay: 'label',
          dataValue: 'value',
          dataArr: [
            {
              name: 'Electricity',
              label: 'Electricity',
              value: 'Electricity'
            },
            {
              name: 'Gas',
              label: 'Gas',
              value: 'Gas'
            },
            {
              name: 'Electricity & Gas,',
              label: 'Electricity & Gas',
              value: 'Dual'
            }
          ]
        }
      }
    }
  },

  [VERTICAL.CAR_INSURANCE]: {
    title: `
      Get a quote in <br class="hidden lg:block" />
      <strong class="font-extrabold">
        less than <br class="hidden lg:block" />
        2 mins
      </strong>
    `,
    redirect: '/car-insurance/',
    formItems: {
      state: {
        component: 'MoleculesStates',
        props: {
          label: '',
          placeholder: 'State'
        }
      },
      type_of_cover: {
        component: 'MoleculesSelectDropdown',
        props: {
          placeholder: 'Level of cover',
          label: '',
          dataInputDisplay: 'label',
          dataListDisplay: 'label',
          dataValue: 'value',
          dataArr: PAGE_DATA.levelOfCover.filter(item => !item?.disabled)
        }
      }
    }
  }
}

export const HERO_ERROR_MAP_OBJ = {
  [VERTICAL.HEALTH_INSURANCE]: {
    life_stage: 'Please select an option',
    postcode: 'Please enter your valid postcode'
  },

  OVHC: {
    life_stage: 'Please select what you\'re looking for',
    visa_type: 'Please select your visa type',
    visa_subtype: 'Please select your visa subclass',
    visa_code: 'Please input your visa code'
  },

  [VERTICAL.LIFE_INSURANCE]: {
    age: 'Please enter a valid age',
    cover_amount: 'Please enter a valid amount'
  },

  'Income Protection': {
    age: 'Please enter a valid age',
    annual_income: 'Please enter a valid amount'
  },

  [VERTICAL.HOME_LOANS]: {
    refinance: 'Please select an option'
  },

  [VERTICAL.ENERGY]: {
    postcode: 'Please enter your valid postcode',
    fuel_type: 'Please select an option'
  },

  [VERTICAL.CAR_INSURANCE]: {
    state: 'Please select an option',
    type_of_cover: 'Please select an option'
  }
}
